import { Navigation, Pagination } from 'swiper';
import { Carousel } from '@publishing/modules/carousel/Carousel';
import type { CarouselTabsTab, CarouselTabsTheme } from './types';
import { TabSlide, getSlideKey } from './TabSlide';
import s from './CarouselTabsSection.module.scss';

export function StandardSlides({
  tab,
  theme,
  variant,
}: {
  tab: CarouselTabsTab;
  theme: CarouselTabsTheme;
  variant: 'pagination' | 'navigation';
}) {
  const isPagination = variant === 'pagination';
  const isSingleSlide = tab.images.length === 1;
  const imageClassName = isPagination
    ? s.carousel_pagination_image
    : s.carousel_navigation_image;

  const singleSlide = (
    <TabSlide
      image={tab.images[0]}
      index={0}
      tab={tab}
      theme={theme}
      imageClassName={imageClassName}
    />
  );

  return (
    <div
      className={
        isPagination
          ? s.carousel_pagination_variant
          : s.carousel_navigation_variant
      }
    >
      {tab.slideTextTop && (
        <p className={s.carousel_slide_text}>{tab.slideTextTop}</p>
      )}
      {isSingleSlide ? (
        isPagination ? (
          <div className={s.carousel_pagination_single}>{singleSlide}</div>
        ) : (
          singleSlide
        )
      ) : (
        <Carousel
          modules={isPagination ? [Navigation, Pagination] : [Navigation]}
          gap={0}
          className={s.carousel_swiper}
          observer
          observeParents
        >
          {tab.images.map((image, index) => (
            <TabSlide
              key={getSlideKey(image, tab.alt, index)}
              image={image}
              index={index}
              tab={tab}
              theme={theme}
              imageClassName={imageClassName}
            />
          ))}
        </Carousel>
      )}
      {tab.slideTextBottom && (
        <p className={s.carousel_slide_text}>{tab.slideTextBottom}</p>
      )}
    </div>
  );
}
